(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-your-vibe"] && !Shopify.designMode) return;
  try {
    
  class WhatsYourVibe {
    constructor(section) {
      this.section = section;
      this.triggers = [...section.querySelectorAll('[data-vibe-trigger]')];
      this.panels = [...section.querySelectorAll('[data-vibe-copy]')];
      this.banners = [...section.querySelectorAll('[data-vibe-banner]')];
      this.defaultItems = [...section.querySelectorAll('[data-vibe-default]')];
      this.products = [...section.querySelectorAll('[data-vibe-product]')];
      this.grid = section.querySelector('[data-vibe-products]');
      this.emptyState = section.querySelector('[data-vibe-empty]');
      this.maxProducts = Number(section.dataset.vibeMaxProducts) || Infinity;

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.selectVibe(trigger));
      });
    }

    selectVibe(trigger, immediate = false) {
      const vibeId = trigger.dataset.vibeTrigger;
      const vibeTag = trigger.dataset.vibeTag;
      const vibeTagAliases = trigger.dataset.vibeTagAliases || '';

      this.section.style.setProperty('--wyv-background', trigger.dataset.vibeBackground);
      this.section.style.setProperty('--wyv-text', trigger.dataset.vibeText);
      this.section.style.setProperty('--wyv-accent', trigger.dataset.vibeAccent);
      this.section.style.setProperty('--wyv-heading-font', trigger.dataset.vibeHeadingFont);
      this.section.style.setProperty('--wyv-body-font', trigger.dataset.vibeBodyFont);
      this.section.style.setProperty('--wyv-card-font', trigger.dataset.vibeCardFont);
      this.updateThemeClasses(trigger);
      this.hideDefaults();
      this.updateActiveSet(this.triggers, 'vibeTrigger', vibeId, true, false);
      this.updateActiveSet(this.panels, 'vibeCopy', vibeId);
      this.updateActiveSet(this.banners, 'vibeBanner', vibeId);

      if (immediate || !this.grid) {
        this.filterProducts(vibeTag, vibeTagAliases);
        return;
      }

      this.grid.classList.add('is-switching');
      window.setTimeout(() => {
        this.filterProducts(vibeTag, vibeTagAliases);
        this.grid.classList.remove('is-switching');
      }, 170);
    }

    updateThemeClasses(trigger) {
      const previousCustomClass = this.section.dataset.activeCustomClass;
      if (previousCustomClass) {
        this.section.classList.remove(...previousCustomClass.split(' ').filter(Boolean));
      }

      [...this.section.classList].forEach((className) => {
        if (className.startsWith('whats-your-vibe--font-') || className.startsWith('whats-your-vibe--button-')) {
          this.section.classList.remove(className);
        }
      });

      this.section.classList.add(`whats-your-vibe--font-${trigger.dataset.vibeFont}`);
      this.section.classList.add(`whats-your-vibe--button-${trigger.dataset.vibeButton}`);

      const nextCustomClass = trigger.dataset.vibeCustomClass;
      if (nextCustomClass) {
        this.section.classList.add(...nextCustomClass.split(' ').filter(Boolean));
      }

      this.section.dataset.activeCustomClass = nextCustomClass || '';
    }

    hideDefaults() {
      this.defaultItems.forEach((item) => {
        item.classList.remove('is-active');
        item.hidden = true;
      });
    }

    updateActiveSet(items, datasetKey, activeId, pressed = false, hideInactive = true) {
      items.forEach((item) => {
        const isActive = item.dataset[datasetKey] === activeId;
        item.classList.toggle('is-active', isActive);
        if (hideInactive) item.hidden = !isActive;

        if (pressed) item.setAttribute('aria-pressed', String(isActive));
      });
    }

    filterProducts(vibeTag, vibeTagAliases) {
      let visibleCount = 0;
      const matchTags = [this.normalizeTag(vibeTag)];

      if (matchTags[0] && !matchTags[0].startsWith('v-')) matchTags.push(`v-${matchTags[0]}`);

      vibeTagAliases
        .split(/[\n,]/)
        .map((tag) => this.normalizeTag(tag))
        .filter(Boolean)
        .forEach((tag) => matchTags.push(tag));

      this.products.forEach((product) => {
        const isMatch = matchTags.some((tag) => product.dataset.vibeTags.includes(`|${tag}|`));
        const isVisible = isMatch && visibleCount < this.maxProducts;
        product.hidden = !isVisible;
        product.classList.toggle('is-hidden', !isVisible);
        if (isVisible) visibleCount += 1;
      });

      if (this.emptyState) this.emptyState.hidden = visibleCount > 0;
    }

    normalizeTag(tag) {
      return String(tag || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    }
  }

  document.querySelectorAll('[data-whats-your-vibe]').forEach((section) => new WhatsYourVibe(section));

  } catch(e) { console.error(e); }
})();
})();
